module.exports = __webpack_public_path__ + "img/battery_1.21d07a85.jpg";